<template>
    <div class="container-fluid mx-3 md:mx-10 my-8">

        <div class="bg-white p-3">

            <h2 class="text-lg font-bold mb-4">Filtrovať</h2>

            <div class="flex flex-wrap">
                <div class="w-1/2">
                    <md-field>
                        <!-- <label for="from">Od</label> -->
                        <datetime
                            type="datetime"
                            v-model="from" 
                            @input="valueChanged"
                            :hour-step="1"
                            :minute-step="10"
                            placeholder="Od"
                            :format="dateFormat" :auto="true" input-class="md-input">
                            <template slot="button-cancel">
                                <md-button class="md-dense md-primary">
                                    Zrušiť
                                </md-button>
                            </template>
                            <template slot="button-confirm">
                                <md-button class="md-dense md-primary">
                                    OK
                                </md-button>
                            </template>
                        </datetime>
                    </md-field>
                </div>
                <div class="w-1/2">
                    <md-field>
                        <!-- <label for="from">Do</label> -->
                        <datetime
                            type="datetime"
                            v-model="to"
                            @input="valueChanged"
                            :hour-step="1"
                            :minute-step="10"
                            placeholder="Do"
                            :format="dateFormat" :auto="true" input-class="md-input">
                            <template slot="button-cancel">
                                <md-button class="md-dense md-primary">
                                    Zrušiť
                                </md-button>
                            </template>
                            <template slot="button-confirm">
                                <md-button class="md-dense md-primary">
                                    OK
                                </md-button>
                            </template>
                        </datetime>
                    </md-field>
                </div>
            </div>

            <div class="flex flex-wrap">
                <div class="w-1/2">
                    <multiselect v-model="usersList"
                    :options="users"
                    :selected="selectedUsers"
                    deselect-label="Can't remove this value"
                    :searchable="false"
                    :close-on-select="true"
                    :multiple="true"
                    :show-labels="false"
                    :hideSelected="true"
                    track-by="id" label="name"
                    @input="valueChanged"
                    placeholder="Filter uživateľa">
                        <template slot="singleLabel" slot-scope="{ option }">{{ option.name }} ({{
                            option.type.name }})
                        </template>
                        
                        <template slot="tag" slot-scope="{ option, remove }">
                            <div class="multiselect__tag" v-ripple>
                                <img v-if="option.image" :src="'/uploads/'+option.image"
                                        class="w-6 h-6 rounded-full mr-3">
                                <span v-if="!option.image" :class="'bg-'+option.color"
                                        class="inicial-box flex items-center justify-center mr-3 text-xs w-6 h-6 text-white rounded-full">{{ getInicials(option) }}</span>
                                <span class="text-sm">{{ option.name }}</span>
                                <span class="multiselect__tag-icon">
                                        <i class="material-icons" @click="remove(option)">close</i>
                                    </span>
                            </div>
                        </template>
                        
                        <template slot="option" slot-scope="{ option }">
                                <span class="flex items-center">
                                    <img v-if="option.image" :src="'/uploads/'+option.image"
                                            class="w-6 h-6 rounded-full mr-3">
                                    <span v-if="!option.image" :class="'bg-'+option.color"
                                            class="inicial-box flex items-center justify-center mr-3 text-xs w-6 h-6 text-white rounded-full">{{ getInicials(option) }}</span>
                                    <span class="text-sm">{{ option.name }} ({{ option.type.name }})</span>
                                </span>
                        </template>
                    </multiselect>

                
                </div>

                <div class="w-1/2">
                    <multiselect v-model="selectedProject" :options="projectNames"
                            id="ajax" label="name" track-by="id"
                            :loading="isLoading"
                            :clear-on-select="true"
                            :options-limit="25"
                            @input="valueChanged"
                            @search-change="fetchProjects"
                            :multiple="true"
                            :searchable="true" :close-on-select="true" :show-labels="false"
                            placeholder="Podľa projektu">
                            <template slot="tag" slot-scope="{ option, remove }">
                            <div class="multiselect__tag" v-ripple>
                                <span class="text-sm">{{ option.name }}</span>
                                <span class="multiselect__tag-icon">
                                        <i class="material-icons" @click="remove(option)">close</i>
                                    </span>
                            </div>
                        </template>
                            </multiselect>
                </div>
            </div>

            <!-- <md-switch v-model="onlyInvoiced" @change="valueChanged" :disabled="all">Zobraziť iba fakturované</md-switch> -->
            <md-switch v-model="all" @change="valueChanged">Zobraziť aj fakturované</md-switch>
            <md-switch v-model="table">Prepnúť na tabuľku</md-switch>


        </div>

        <div v-if="!hasRecords" class="flex items-center py-10">
            <h1 class="text-lg mx-auto">Nenašli sa pre tento filter žiadne záznamy.</h1>
        </div>
    
        <div v-if="!table">
            <div v-for="stat in stats" :key="stat.project">
                <h2 class="text-xl mb-4 mt-4 flex items-center"><span class="rounded-full h-6 w-1 bg-orange-500 inline-block mr-2"></span> {{stat.project}} <md-button
                        @click="() => markAsInvoiced(stat)"
                        class="md-dense"
                        :class="wholeGroupIsInvoiced(stat) ? `md-accent` : ``">
                        {{ wholeGroupIsInvoiced(stat) ? `Fakturované` : `Fakturovať` }}
                    </md-button></h2>
                <div class="flex flex-wrap -mx-3">
                    <div v-for="(users, date) in stat.dates" class="px-3 w-full mb-4 items-stretch" :key="date">
                        <div class="bg-white shadow px-3 pb-3 h-full flex flex-col">
                            <div class="border-b border-gray-100 py-3">
                                <span class="text-lg">{{ formatDate(date) }}</span>
                            </div>
                            <activity-stack v-for="user in users" :key="user.id" :project="user" :ivoiced.sync="invoiced" />
                        </div>
                    </div>
                    
                    <div class="text-xl text-right w-full pr-3">
                        Celkovo za projekt: <span class="font-bold">{{ formatTotal(stat.total_per_month) }}</span>
                    </div>
                </div>
            </div>
            <div class="text-xl text-right w-full mt-3">
                Celkovo za obdobie: <span class="font-bold">{{ formatTotal(totalTime) }}</span>
            </div>
        </div>
        <div v-else>
            <div v-for="stat in stats">
                <h2 class="capitalize text-xl mb-4 mt-4 flex items-center"><span class="rounded-full h-6 w-1 bg-orange-500 inline-block mr-2"></span> {{stat.project}}</h2>
                <div class="flex flex-wrap -mx-3">
                    <div v-for="(users, date) in stat.dates" class="bg-white w-full shadow px-3 mb-4 pb-3 h-full flex flex-col">
                        <div class="border-b border-gray-100 py-3">
                            <span class="text-lg">{{ formatDate(date) }}</span>
                        </div>
                        
                        <div v-for="project in users" class="w-full flex flex-col">
                            <span class="font-bold">
                                {{ project.user }}
                            </span>
                            <table class="px-3 text-left w-full">
                                <thead>
                                    <tr>
                                        <th>Poznámka</th>
                                        <th>Od</th>
                                        <th>Do</th>
                                        <th>Oprava</th>
                                        <th class="text-right">Trvanie</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="activity in project.activities" >
                                        <td>{{ activity.note }}</td>
                                        <td>{{ formatActivityDate(activity.from) }}</td>
                                        <td>{{ formatActivityDate(activity.to) }}</td>
                                        <td>{{ activity.fixing ? `Áno` : `Nie` }}</td>
                                        <td class="text-right">{{ formatTotal(activity.length) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    
                    <div class="text-xl text-right w-full pr-3">
                        Celkovo za projekt: <span class="font-bold">{{ formatTotal(stat.total_per_month) }}</span>
                    </div>
                </div>
            </div>
            <div class="text-xl text-right w-full mt-3">
                Celkovo za obdobie: <span class="font-bold">{{ formatTotal(totalTime) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {formatTotal, hasPermission, getInicials, dynamicSort} from '../utils';
    import ActivityStack from './Stats/ActivityStack';

    export default {
        name: "Stats",
        components: {ActivityStack},

        metaInfo: () => ({
            title: "Štatistiky"
        }),
        
        beforeCreate() {
            this.$store.dispatch("fetchStats");
            this.$store.dispatch("fetchUsers");
        },

        beforeMount() {
            this.fetchProjects();
            this.from = moment().startOf("month").toISOString()
            this.to = moment().toISOString()

        },
        
        data: () => ({
            invoiced: {},
            table: false,
            selectedUsers: [],

            usersList: [],
            from: "",
            to: "",
            onlyInvoiced: false,
            selectedProject: "",
            isLoading: false,
            all: false,

            queryTimeoutThreshold: null,

            dateFormat: "dd.MM.yyyy HH:mm:ss",
        }),
        
        computed: {
            ...mapState({
                stats: state => state.stats.stats,
                user: state => state.account.user,
                users: state => state.users.all,
                projectNames: state => state.projects.all

            }),

            hasRecords() {
                return this.stats.length > 0;
            },

            totalTime() {
                let total = 0;
                this.stats.map(item => {
                    total += item.total_per_month;
                })

                return total;
            }
        },
        
        methods: {
            markAsInvoiced(group) {
                let ids = [];

                let wholeGroupIsInvoiced = this.wholeGroupIsInvoiced(group);

                for(let g in group.dates) {
                    for(let user in group.dates[g]) {
                        for(let activity of group.dates[g][user].activities) {
                            activity.invoiced = wholeGroupIsInvoiced ? false : true;
                            ids.push(activity);
                        }
                    }
                }

                let data = Object.assign({}, {ids});

                this.$store.dispatch("saveActivityMulti", data)
                    .then(() => {
                        this.valueChanged();
                    });
            },

            wholeGroupIsInvoiced(group) {
                let invoiced = [];
                for(let g in group.dates) {
                    for(let user in group.dates[g]) {
                        for(let activity of group.dates[g][user].activities) {
                            invoiced.push(activity.invoiced ? 'true': 'false');
                        }
                    }
                }

                if(invoiced.includes('false')) {
                    return false;
                }

                return true;
            },

            fetchProjects(query = "") {
                clearTimeout(this.queryTimeoutThreshold);
                this.queryTimeoutThreshold = setTimeout(() => {
                    this.isLoading = true;
                    this.$store.dispatch("fetchProjects", {
                        search: query,
                        all: true
                    }).then(() => {
                        this.isLoading = false
                    })
                }, 500);
            },

            formatTotal(seconds) {
                return formatTotal(seconds);
            },
            
            formatDate(date) {
                return moment(date, "YYYYMMDD").format("DD.MM.YYYY");
            },
            
            formatActivityDate(datetime) {
                return moment(datetime, "YYYY-MM-DD hh:mm:ss").format("DD.MM.YYYY hh:mm:ss");

            },

            getInicials(user) {
                return getInicials(user.name, user.image);
            },

            valueChanged() {
                let mems = [];
                let projects = [];
                let data = Object.assign({});

                for (let member of this.usersList) {
                    mems.push(member.id);
                }

                for (let project of this.selectedProject) {
                    projects.push(project.id);
                }

                if(mems.length > 0)
                    data.users = mems;

                data.from = this.from;
                data.to = this.to;

                if(!this.all)
                    data.invoiced = this.onlyInvoiced ? '1' : '0';
                
                if(projects.length > 0)
                    data.project_id = projects;

                this.$store.dispatch("fetchStats", data);
            }
        }
    }
</script>

<style lang="scss">
    .vdatetime-popup__header,
    .vdatetime-calendar__month__day--selected > span > span,
    .vdatetime-calendar__month__day--selected:hover > span > span {
        @apply bg-orange-500;
    }

    .vdatetime-year-picker__item--selected,
    .vdatetime-time-picker__item--selected,
    .vdatetime-popup__actions__button {
        @apply text-orange-500;
    }

    .vdatetime-popup__actions__button {
        @apply p-0;
    }

    .vdatetime-popup__actions {
        @apply px-0 pb-3 pt-2;
    }
</style>